import React from 'react';
import { Link } from 'react-router-dom';

function PolitiqueRetourPage() {
    return (
        <main>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: "url('img/bg/breadcrumb_bg.jpg')" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h2 className="title">Politique de retour et d’échange</h2>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Politique de retour</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="privacy-policy-area" style={{ padding: '100px 0', backgroundColor: '#fff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="privacy-policy-content">
                                <h3 className="title mb-4">Politique de retour et d’échange</h3>
                                <p className="date mb-4">Mise à jour 18/12/2025</p>

                                <p>Chez Kaki, nous plaçons la satisfaction de nos clients et le confort de leurs animaux au cœur de notre engagement. Chaque produit est conçu et sélectionné avec le plus grand soin afin de garantir qualité, hygiène et bien-être.</p>
                                <p>Conscients toutefois que le choix d’un vêtement pour animal peut parfois nécessiter un ajustement (faute de taille), nous avons mis en place une politique de retour claire, équitable et transparente, pensée pour offrir une expérience d’achat sereine et sans ambiguïté.</p>
                                <p>Notre objectif est d’établir une relation de confiance durable avec nos clients. C’est pourquoi nous restons à l’écoute, disponibles et proactifs pour trouver, dans la mesure du possible, la solution la plus adaptée à chaque situation : échange, conseil personnalisé ou accompagnement après-vente.</p>
                                <p>Nous mettons tout en œuvre pour que chaque client se sente considéré, rassuré et pleinement satisfait, tout en respectant les impératifs d’hygiène et de qualité propres aux vêtements pour animaux.</p>

                                <h4 className="mt-4 mb-3">1. Délai de retour</h4>
                                <p>Vous disposez de 14 jours calendaires à compter de la date de réception de votre commande pour demander un retour ou un échange.</p>

                                <h4 className="mt-4 mb-3">2. Conditions de retour</h4>
                                <p>Pour être accepté, l’article doit impérativement :</p>
                                <ul>
                                    <li>Être neuf, (porté une seule fois pour le tester), non lavé</li>
                                    <li>Ne présenter aucune trace de poils, saleté ou odeur</li>
                                    <li>Être retourné dans son emballage d’origine, avec étiquettes intactes</li>
                                </ul>
                                <p className="text-danger mt-2">⚠️ Pour des raisons d’hygiène, tout article représentant des traces de poils, saleté ou odeur par un animal ne pourra pas être repris ou échangé.</p>

                                <h4 className="mt-4 mb-3">3. Articles non éligibles au retour</h4>
                                <p>Les retours ne sont pas acceptés dans les cas suivants :</p>
                                <ul>
                                    <li>Articles personnalisés ou sur mesure</li>
                                    <li>Produits endommagés après réception</li>
                                    <li>Retours effectués hors délai</li>
                                </ul>

                                <h4 className="mt-4 mb-3">4. Procédure de retour</h4>
                                <p>Avant tout envoi, merci de :</p>
                                <ol>
                                    <li>Nous contacter par e-mail ou via nos réseaux sociaux</li>
                                    <li>Indiquer votre date de commande et le motif du retour</li>
                                    <li>Attendre notre confirmation avant l’expédition</li>
                                </ol>
                                <p>Tout retour non validé au préalable pourra être refusé.</p>

                                <h4 className="mt-4 mb-3">5. Frais de retour</h4>
                                <ul>
                                    <li>Les frais de retour sont à la charge du client</li>
                                    <li>En cas d’erreur de notre part (article défectueux ou incorrect), les frais seront pris en charge par Kaki</li>
                                </ul>

                                <h4 className="mt-4 mb-3">6. Échange ou remboursement</h4>
                                <ul>
                                    <li><strong>Échange :</strong> possible selon la disponibilité des stocks</li>
                                    <li><strong>Remboursement :</strong> effectué sous 7 à 10 jours après réception et vérification du produit s’il est défectueux ou incorrect.</li>
                                </ul>
                                <p>Le remboursement se fait via le même moyen de paiement utilisé lors de l’achat.</p>

                                <h4 className="mt-4 mb-3">7. Produits défectueux ou erreur de commande</h4>
                                <p>Si vous recevez un article défectueux ou non conforme, merci de nous contacter sous 48 heures après réception avec des photos à l’appui.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default PolitiqueRetourPage;
